import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faCalendarPlus, faCog } from '@fortawesome/free-solid-svg-icons'
import { Link } from "gatsby";

import meet_logo from "../assets/img/meet_logo.png";
import { logout } from "../helpers/auth";

const LeftSidebar = () => {
    return (
        <div className="col-md-3 left_sidebar">
            <div className="meet_colm-one">
                <div className="m_logo">
                    <a href="/">
                        <img src={meet_logo} />
                    </a>
                </div>
                <ul className="list-unstyled">
                    <li>
                        <Link
                            className="h_li"
                            to="/dashboard"
                            activeClassName="active"
                        >
                            <FontAwesomeIcon className="f_icon" icon={faHome} />
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="h_li"
                            to="/profile"
                            activeClassName="active"
                        >
                            <FontAwesomeIcon className="f_icon" icon={faCalendarPlus} />
                            Profile
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="h_li"
                            to="/settings"
                            activeClassName="active"
                        >
                            <FontAwesomeIcon className="f_icon" icon={faCog} />
                            Settings
                        </Link>
                    </li>
                </ul>
                <div className="log_out" onClick={() => logout()}>Log out</div>
            </div>
        </div>
    ) 
}

export default LeftSidebar;